import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
export const supportProxy2OtherWin = (name) => [apis.contactApiImpl, apis.dbInterfaceApiImpl, apis.mailApiImpl].includes(name);
const dbBrideProxyConfig = {
    target: () => masterApi.requireLogicalApi(apis.dbInterfaceApiImpl),
    namespace: apis.dbInterfaceApiImpl,
    apis: [
        'close',
        'closeSpecific',
        'getByRangeCondition',
        'getByEqCondition',
        'getTableCount',
        'getById',
        'getByIds',
        'getByIndexIds',
        'deleteByByRangeCondition',
        {
            key: 'deleteById',
            priorityConfig: ['high', 3 * 60 * 1000],
        },
        'put',
        'bulkPut',
        {
            key: 'putAll',
            priorityConfig: ['high', 3 * 60 * 1000],
        },
    ],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            console.log('[bridge/config.mail]', isMainAccount, env);
            return null;
        }
        if (page !== 'dataBg') {
            return 'dataBg';
        }
        return null;
    },
    priorityConfig: ['high', 30 * 1000],
};
const mailBridgeProxyConfig = {
    target: () => masterApi.requireLogicalApi(apis.mailApiImpl),
    namespace: apis.mailApiImpl,
    apis: [
        'deleteUserFolder',
        'updateMessageInfos',
        'updateUserFolder',
        'createUserFolder',
        'syncMailFolder',
        {
            key: 'doListMailBox',
            priorityConfig: ['high', 30 * 1000],
        },
        'cleanPushConfig',
        'getPushConfig',
        'setPushConfig',
        'doGetFoldersForPushConfig',
        'doListMailBoxEntities',
        'doListThreadMailBoxEntities',
        'doGetThreadMailById',
        'doGetMailContent',
        'handleSendMDN',
        'gptEmailWrite',
        'gptEmailRetouch',
        'getGPTQuota',
        'getGptConfig',
        'getGptRecord',
        'doTranslateGPTAiContent',
        'doGetMailContentIM',
        'doGetThreadMailContent',
        'doMarkMailInfFolder',
        'doMarkMailPerferred',
        'doMarkMail',
        'recordMailRead',
        'doMarkMailDefer',
        'doMarkMailDeferAll',
        'doDeleteMail',
        'doDeleteThreadMail',
        'doMoveMail',
        'doMoveThreadMail',
        'doReportOrTrustMail',
        'doReplayMail',
        'doReplayMailWithAttach',
        'doForwardMail',
        'doForwardMailAsAttach',
        'doEditMail',
        'doNeedSaveTemp',
        'doSaveTemp',
        'doUploadAttachment',
        'doGetContentFromDB',
        'doSaveContentToDB',
        'doWithdrawMail',
        'doCheckReadStatus',
        'doGetMailReadCount',
        'doGetMailReadDetail',
        'getThumbUpInfo',
        'setThumbUpCreate',
        'getMailConfig',
        'setMailConfig',
        'doWriteMailToServer',
        'initModel',
        'getContractItemByEmail',
        'doCancelCompose',
        'doUpdateMailBoxStat',
        'doGetMailByReplyMId',
        'doFastSend',
        'replyExternalThumbMail',
        'doGetReplayContentModel',
        'doGetGroupMailStatus',
        'getRelatedMail',
        'getFilePreviewUrl',
        'updateMessageTags',
        'refreshDbMailsByTag',
        'doAdvanceSearchMail',
        'getMailContentInDb',
        'getMailContentTableInDb',
        'getTranslateContent',
        'getEnglishGrammar',
        'syncTranslateContentToDb',
        'getLastMailSyncTime',
        'doListMailEntitiesFromDb',
        'doGetThreadMailContentFromDb',
        'doLocalSearchMail',
        'doAddAttachment',
        'doExportMail',
        'doExportMailAsEml',
        'doExportThreadMailAsZip',
        'doGetMailTypeById',
        'doGetMailTypeByIds',
        'doSaveMailSearchRecord',
        'doGetMailSearchRecords',
        'doDeleteMailSearchRecord',
        'doGetPraiseMedals',
        'doGetAllStrangers',
        'newMailIntoStrangers',
        'newUsersIntoEmailList',
        'doGetFullTaskMailList',
        'doGetRecent3Strangers',
        'mkDownloadDir',
        'listAttachments',
        'assembleMail',
        'doParseEml',
        'doGetParsedEmlFromDb',
        'doUploadMail',
        'doChangeMailEncoding',
        'requestDelivery',
        'requestDeliveryWm',
        'triggerReceive',
        'getMailDeliveryDetail',
        {
            key: 'doImportMails',
            priorityConfig: ['high', 120 * 1000],
            proxyTarget(page, isMainAccount, env) {
                if (page !== 'frontPage' || env !== 'electron') {
                    return null;
                }
                if (isMainAccount) {
                    return 'dataBg';
                }
                return 'accountBg';
            },
        },
        {
            key: 'syncAllMails',
            priorityConfig: ['high', 30 * 1000],
            proxyTarget(page, isMainAccount, env) {
                if (page !== 'frontPage' || env !== 'electron') {
                    return null;
                }
                if (isMainAccount) {
                    return 'dataBg';
                }
                return 'accountBg';
            },
        },
        {
            key: 'doAutoSaveFilesInMail',
            priorityConfig: ['low', 30 * 1000],
            proxyTarget(page, isMainAccount, env) {
                if (page !== 'frontPage' || env !== 'electron') {
                    return null;
                }
                if (isMainAccount) {
                    return 'dataBg';
                }
                return 'accountBg';
            },
        },
        {
            key: 'clearExpiredMails',
            priorityConfig: ['low', 30 * 1000],
            proxyTarget(page, isMainAccount, env) {
                if (page !== 'frontPage' || env !== 'electron') {
                    return null;
                }
                if (isMainAccount) {
                    return 'dataBg';
                }
                return 'accountBg';
            },
        },
    ],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const contactBrideProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.contactApiImpl);
    },
    namespace: apis.contactApiImpl,
    apis: [
        'doUpdateContact',
        'doDeleteContact',
        'doInsertContact',
        'uploadIcon',
        'doInsertOrReplacePersonal',
        'doGetContactByItem',
        'doGetServerContactByYunxin',
        'doGetContactByOrgIds',
        'doGetContactByOrgId',
        'doGetPersonalContact',
        'getRecentContactList',
        'addRecentContact',
        'getMaillistMember',
        'createMaillist',
        'updateMaillist',
        'deleteMaillist',
        'listUserDomain',
        'listUserMaillist',
        'getMaillist',
        'getMaillistConfig',
        'checkMaillistAccountName',
        'doSearchTeamContact',
        'doSearchAllContact',
        'doSearchContact',
        'doGetContactById',
        'doGetOrgContactListByIM',
        'doGetOrgContactListByTeamId',
        'doUpdateContactById',
        'doUpdateContactModel',
        'doGetContactOrg',
        'doGetContactInMailList',
        'doGet',
        'doGetOrgList',
        'doGetTeamList',
        'getContactSyncTimes',
        'doGetAllContactList',
        'doGetAllOrgContact',
        'doGetOrgContactListByOrgId',
        'doGetPersonalOrg',
        'doDeletePersonalOrg',
        'doInsertPersonalOrg',
        'doUpdatePersonalOrg',
        'doGetPersonalOrgContactByOrgId',
        'doInsertContactByPersonalOrgId',
        {
            key: 'doGetBKContactReady',
            proxyTarget(page, isMainAccount) {
                if (page === 'frontPage') {
                    return isMainAccount ? 'dataBg' : 'accountBg';
                }
                return null;
            },
        },
        {
            key: 'setEDMSync',
            proxyTarget(page) {
                if (page === 'frontPage') {
                    return 'dataBg';
                }
                return null;
            },
        },
        {
            key: 'syncAll',
            proxyTarget(page, isMainAccount) {
                if (!isMainAccount) {
                    return 'accountBg';
                }
                console.log('[bridge]config.syncall page:', page);
                return null;
            },
        },
        {
            key: 'doSyncCustomer',
            priorityConfig: ['high', 3 * 60 * 1000],
            proxyTarget(page) {
                if (page === 'frontPage') {
                    return 'dataBg';
                }
                return null;
            },
        },
        {
            key: 'doSearchNew',
            funcname: 'doSearchInMemory',
            backup(err) {
                const _apiname = '_$doSearchNew';
                const $tempMethod = masterApi.requireLogicalApi(apis.contactApiImpl)[_apiname];
                if (typeof $tempMethod !== 'function') {
                    throw err;
                }
                const dataTrackerApi = masterApi.requireLogicalApi(apis.dataTrackerApiImp);
                dataTrackerApi.track('pc_contact_search_error', {
                    msg: lodashGet(err, 'message', ''),
                    keyword: lodashGet(err, 'config.args[0].query', ''),
                    recordSubAccount: false,
                });
                const { args } = err.config;
                return masterApi.requireLogicalApi(apis.contactApiImpl)[_apiname](...args);
            },
            proxyTarget(page, isMainAccount, env) {
                if (page !== 'frontPage' || env !== 'electron') {
                    return null;
                }
                console.log('[xxx]', isMainAccount, env);
                return 'dataBg';
            },
        },
        {
            key: 'doGetContactByEmail',
            funcname: 'doGetContactByEmailInMemoryMode',
            enableProxy: false,
            backup(err) {
                const _apiname = '_$doGetContactByEmail';
                const $tempMethod = masterApi.requireLogicalApi(apis.contactApiImpl)[_apiname];
                if (typeof $tempMethod !== 'function') {
                    throw err;
                }
                const { args } = err.config;
                return masterApi.requireLogicalApi(apis.contactApiImpl)[_apiname](...args);
            },
            proxyTarget(page, isMainAccount, env) {
                if (page !== 'frontPage' || env !== 'electron') {
                    return null;
                }
                if (isMainAccount) {
                    return 'dataBg';
                }
                return 'accountBg';
            },
        },
    ],
    proxyTarget(page, isMainAccount, env) {
        console.log('[bridge]proxy.env:', env);
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const edmRoleBrideProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.edmRoleApiImpl);
    },
    namespace: apis.edmRoleApiImpl,
    apis: [
        {
            key: 'setBKEdmRoleData',
            proxyTarget(page) {
                if (page === 'frontPage') {
                    return 'dataBg';
                }
                return null;
            },
        },
    ],
    proxyTarget(page, isMainAccount, env) {
        console.log('[bridge]proxy.env:', env);
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const storeBridgeProxyConfig = {
    target() {
        return masterApi.requireDataStoreApi(apis.defaultDataStoreApiImpl);
    },
    namespace: apis.defaultDataStoreApiImpl,
    apis: ['put', 'get', 'del', 'clear'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const mailConfBridgeProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.mailConfApiImpl);
    },
    namespace: apis.mailConfApiImpl,
    apis: ['setMailSenderName', 'getMailSenderInfo'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const signatureBridgeProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.mailSignatureImplApi);
    },
    namespace: apis.mailSignatureImplApi,
    apis: ['doGetSignList', 'doDeleteSign', 'doSetDefaultSign', 'doAddSign', 'doUpdateSign', 'doGetSignPreview', 'doGetSignTemplateAndProfile', 'doGetDefaultSign'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const templateBridgeProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.mailTemplateImplApi);
    },
    namespace: apis.mailTemplateImplApi,
    apis: ['doGetMailTemplateList', 'doDeleteMailTemplate', 'doSaveMailTemplate', 'doSaveMailTemplateUseTime', 'doGetMailTemplateDetail'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const fileBridgeProxyConfig = {
    target() {
        return masterApi.getFileApi();
    },
    namespace: apis.defaultFileApi,
    apis: ['download', 'saveDownload', 'saveZip', 'getFileInfo', 'testLocalFile', 'show', 'delFileInfo', 'getFsDownloadStatus'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const taskBridgeProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.taskMailImplApi);
    },
    namespace: apis.taskMailImplApi,
    apis: ['doGetTaskMailContent', 'getTaskMailInDb', 'doUrgeTask', 'doOperateTask'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const icsBridgeProxyConfig = {
    target() {
        return masterApi.requireLogicalApi(apis.icsApiImpl);
    },
    namespace: apis.icsApiImpl,
    apis: ['doGetIcsInfo', 'doOperateIcs'],
    proxyTarget(page, isMainAccount, env) {
        if (env !== 'electron') {
            return null;
        }
        if (page === 'frontPage' && !isMainAccount) {
            return 'accountBg';
        }
        return null;
    },
};
const res = process.env.BUILD_ISEDM
    ? [
        mailBridgeProxyConfig,
        dbBrideProxyConfig,
        contactBrideProxyConfig,
        edmRoleBrideProxyConfig,
        storeBridgeProxyConfig,
        signatureBridgeProxyConfig,
        mailConfBridgeProxyConfig,
        templateBridgeProxyConfig,
        fileBridgeProxyConfig,
        taskBridgeProxyConfig,
        icsBridgeProxyConfig,
    ]
    : [
        mailBridgeProxyConfig,
        dbBrideProxyConfig,
        contactBrideProxyConfig,
        storeBridgeProxyConfig,
        signatureBridgeProxyConfig,
        mailConfBridgeProxyConfig,
        templateBridgeProxyConfig,
        fileBridgeProxyConfig,
        taskBridgeProxyConfig,
        icsBridgeProxyConfig,
    ];
export default res;
